import { render } from "./MessageSearchForm.vue?vue&type=template&id=ab39d480&ts=true"
import script from "./MessageSearchForm.vue?vue&type=script&lang=ts"
export * from "./MessageSearchForm.vue?vue&type=script&lang=ts"

import "./MessageSearchForm.vue?vue&type=style&index=0&id=ab39d480&lang=css"

import exportComponent from "/home/cipherx/.thelounge-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"client/components/MessageSearchForm.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ab39d480"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ab39d480', __exports__)) {
    api.reload('ab39d480', __exports__)
  }
  
  module.hot.accept("./MessageSearchForm.vue?vue&type=template&id=ab39d480&ts=true", () => {
    api.rerender('ab39d480', render)
  })

}


export default __exports__